// extracted by mini-css-extract-plugin
export default {"root":"Hidden-root-f624dc6a06a34ed4aae4822ef75b9617"};